<template>
  <div>
    <Form :model="searchCondition" :label-width="90" inline>
      <div>
        <FormItem label="订单编号">
          <Input
            v-model="searchCondition.order_number"
            placeholder="请输入订单编号关键字"
            class="com-width"
            clearable
            @keydown.native.prevent.enter="onSearch"
          ></Input>
        </FormItem>
        <FormItem label="发货单号">
          <Input
            v-model="searchCondition.logistics_number"
            placeholder="请输入发货单号关键字"
            class="com-width"
            clearable
            @keydown.native.prevent.enter="onSearch"
          ></Input>
        </FormItem>
        <FormItem label="物流单号">
          <Input
            v-model="searchCondition.logistics_no"
            placeholder="请输入物流单号关键字"
            class="com-width"
            clearable
            @keydown.native.prevent.enter="onSearch"
          ></Input>
        </FormItem>
        <FormItem label="收货人">
          <Input
            v-model="searchCondition.consignee"
            placeholder="请输入收货人关键字"
            class="com-width"
            clearable
            @keydown.native.prevent.enter="onSearch"
          ></Input>
        </FormItem>
      </div>
      <FormItem label="收货人手机号">
        <Input
          v-model="searchCondition.mobile"
          placeholder="请输入收货人手机号"
          class="com-width"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Input>
      </FormItem>
      <FormItem label="发货商品">
        <Input
          v-model="searchCondition.product_name"
          placeholder="请输入发货商品关键字"
          class="com-width"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Input>
      </FormItem>
      <FormItem label="生成时间">
        <Date-picker
          ref="formDate"
          type="datetimerange"
          placeholder="开始日期 — 结束日期"
          @on-change="onDateRange"
          style="width:280px;"
          :editable="false"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Date-picker>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/ship/index"
        :search="searchCondition"
        :rowsFormatter="onrowsFormatter"
        selectType
        keyField="logistics_id"
        method="get"
      >
        <template slot-scope="{row}" slot="action">
          <div class="table-btn-box">
            <Button type="text" size="small" @click="onDetail(row)" :to="{name:'OrderShipDetail',query:{id:row.logistics_id}}">详情</Button>
          </div>
        </template>
      </Grid>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderShipList",
  data() {
    return {
      tableColumns: [
        {
          title: "订单编号",
          key: "order_number",
          align: "center",
          minWidth: 150
        },
        {
          title: "发货单号",
          key: "logistics_number",
          align: "center",
          minWidth: 160
        },
        {
          title: "物流单号",
          key: "logistics_no",
          align: "center",
          minWidth: 160
        },
        {
          title: "发货商品",
          key: "product_name",
          align: "left",
          minWidth: 150
        },
        {
          title: "物流公司",
          key: "logistics_name",
          align: "center",
          minWidth: 200
        },
        {
          title: "物流费用",
          key: "logistics_fee_yuan",
          align: "center",
          minWidth: 100
        },
        { title: "收货人", key: "consignee", align: "center", minWidth: 120 },
        {
          title: "收货人手机号",
          key: "mobile",
          align: "center",
          minWidth: 120
        },
        {
          title: "生成时间",
          key: "created_at",
          align: "center",
          minWidth: 150
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 120,
          fixed: "right"
        }
      ],
      searchCondition: {
        order_number: "",
        logistics_number: "",
        logistics_no: "",
        consignee: "",
        mobile: "",
        product_name: "",
        start_time: "",
        end_time: ""
      }
    };
  },
  methods: {
    onrowsFormatter(rows) {
      rows.forEach(i => {
        i.created_at = this.$pub.timestampToTime(i.created_at);
        i.logistics_fee_yuan = this.$pub.calcPrice(i.logistics_fee);
      });
    },
    onDateRange(range) {
      this.searchCondition.start_time = range[0];
      this.searchCondition.end_time = range[1];
    },
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.order_number = "";
      this.searchCondition.logistics_number = "";
      this.searchCondition.logistics_no = "";
      this.searchCondition.consignee = "";
      this.searchCondition.mobile = "";
      this.searchCondition.product_name = "";
      this.searchCondition.start_time = "";
      this.searchCondition.end_time = "";
      this.$refs.formDate.handleClear();
      this.$refs.grid.searchRefresh();
    }
  }
};
</script>